import { Component, OnInit } from '@angular/core';
import { AuthService, PhoneHelperService, ViewportService } from 'epay-library';
import { CommonSettings } from 'epay-library';
import { Router } from '@angular/router';

import { EMPLOYER_PROFILE_SETTINGS_URL } from 'epay-library';

@Component({
  selector: 'epay-creditcard-landing',
  templateUrl: './creditcard.landing.component.html',
})
export class EMPCreditCardLandingComponent implements OnInit {
  pagetitle = 'Employer: Create Credit Card Payment';
  baseurl = '';
  daysToShowCCHistory: number;
  username = '';
  usertype = '';
  isManager = '';
  numOfUsers = 0;
  accountKeys: string[] = [];
  isLoggedIn = false;
  isLoading = false;
  accountAddress = '';
  accountCSZ = '';
  accountEmail = '';
  accountPhone = '';
  employerName = '';
  employerEin = '';
  isMobile = false;
  profileSettingsUrl = EMPLOYER_PROFILE_SETTINGS_URL;
  phoneMask = '';
  countryId = '';

  constructor(
    private authservice: AuthService,
    private router: Router,
    private viewpointService: ViewportService,
    private phoneHelperService: PhoneHelperService
  ) {
    this.baseurl = CommonSettings.BaseApi;
    this.daysToShowCCHistory = +CommonSettings.DaysToShowEFTFileHistory;
  }

  ngOnInit() {
    this.authservice.isLoggedIn.subscribe(
      (status: any) => (this.isLoggedIn = status)
    );
    if (this.isLoggedIn) {
      this.authservice.currentUserName.subscribe(
        (name: string) => (this.username = name.toUpperCase())
      );
      this.authservice.currentUserType.subscribe(
        (type: string) => (this.usertype = type)
      );
      this.authservice.currentAccountAddress.subscribe((address: string) => {
        this.accountAddress = address;
        this.countryId = address.slice(-2);
        this.setPhoneMask(this.countryId)!;
        console.log(this.countryId + ' ' + this.phoneMask);
      });
      this.authservice.currentAccountPhone.subscribe(
        (phone: string) => (this.accountPhone = phone)
      );
      this.authservice.currentAccountEmail.subscribe(
        (email: string) => (this.accountEmail = email)
      );
      this.authservice.currentEmployerName.subscribe(
        (empName: string) => (this.employerName = empName)
      );
      this.authservice.currentUserAccountManager.subscribe(
        (manager: string) => (this.isManager = manager)
      );
      this.authservice.currentNumberofAccountUsers.subscribe(
        (acctCount: string) => (this.numOfUsers = +acctCount)
      );
      this.authservice.currentEmployerEIN.subscribe(
        (ein: string) => (this.employerEin = ein)
      );
    }
    this.viewpointService.IsMobile.subscribe(
      (mobile: any) => (this.isMobile = mobile)
    );
  }

  goToProfile() {
    this.router.navigate([EMPLOYER_PROFILE_SETTINGS_URL]);
  }

  setPhoneMask(regionCode: string) {
    this.phoneMask = this.phoneHelperService.getMask(regionCode);
  }
}
